import {useCallback, useState} from "react";
import useAuthentication from "../useAuthentication";
import useFirebase from "../../../util/useFirebase";

const useRequestResetPassword = () => {
  const {t} = useAuthentication();

  const {getAuth, sendPasswordResetEmail} = useFirebase();

  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const [error, setError] = useState(null);
  const updateEmail = useCallback(e => setEmail(e.target.value), []);

  const handleReset = useCallback(e => {
    e.preventDefault();

    if (email.length === 0) {
      return setError(t("error_missing_email"));
    } else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return setError(t("error_invalid_email"));
    }

    setSending(true);

    sendPasswordResetEmail(getAuth(), email).finally(e => {
      setSent(true);
      setError(null);
    });
  }, [email, t, getAuth, sendPasswordResetEmail]);

  return {
    t,
    sending,
    sent,
    handleReset,
    error,
    email,
    updateEmail
  };
}

export default useRequestResetPassword;
